import type { Capability } from 'owa-capabilities';
import type { MailboxInfo } from 'owa-client-types';
import { RegisterForAccountStateChange } from 'owa-account-source-list';
import { type AccountSource } from 'owa-account-source-list-store';
import { isAccountFeatureEnabled, isGlobalFeatureEnabled } from 'owa-feature-flags';
import { areAnyAccountsEnterpriseOrPremiumConsumer } from './utils/areAnyAccountsEnterpriseOrPremiumConsumer';
import { getModuleContextMailboxInfo } from 'owa-module-context-mailboxinfo';
import { getUserPremiumStatus } from 'owa-user-premium-status-store';

let checked = false;
let enabled = false;

/**
 * This capability is used to determine if quick parts capabilities should be supported.
 *
 * NOTE: Please see the README for more information on how the
 * capability functions must be implemented and used.
 *
 */
export const quickPartsCapability: Capability = {
    // If the user is eligible for the feature, e.g they are busisness or consumer premium users
    isEnabled: (_mailboxInfo?: MailboxInfo) => {
        if (isGlobalFeatureEnabled('acct-templates-quickparts-premiumStatus')) {
            return getUserPremiumStatus();
        } else {
            if (checked) {
                return enabled;
            }

            enabled = areAnyAccountsEnterpriseOrPremiumConsumer();
            checked = true;

            RegisterForAccountStateChange(onAccountsChanged, onAccountsChanged);

            return enabled;
        }
    },
    // If the feature has rolled out to the user by account
    isSupported: (mailboxInfo?: MailboxInfo) => {
        mailboxInfo = mailboxInfo || getModuleContextMailboxInfo();
        return isAccountFeatureEnabled('cmp-quick-parts', mailboxInfo);
    },
};

// Callback for when an account is added or removed
const onAccountsChanged = async (_accountSource: AccountSource) => {
    enabled = areAnyAccountsEnterpriseOrPremiumConsumer();
};
